import styled from 'styled-components'

const StoryTitleBig = styled.h1`
  font-size:2.4rem;
  margin: 5px 0px!important;
  ${props => props.center ? 'text-align:center;' : ''}
  @media ${props =>props.theme.boxLayoutQuery} {
    font-size:4rem;
  }
  @media (max-width: 320px) {
    font-size:2rem;
  }
`;

export default StoryTitleBig